import React from 'react';
import classnames from 'classnames';

import styles from './hyperlink.scss';
import textStyles from './text.scss';
import { DEFAULT_FONT_FAMILY, DEFAULT_FONT_SIZE } from '../constants';
import HyperlinkInterstitialModal from '../hyperlink-interstitial-modal';

export default class Hyperlink extends React.PureComponent {

  self = React.createRef();

  state = { openModal: false };

  focus = (focusOptions) => {
    this.self.current.focus(focusOptions);
  };

  handleClick = () => {
    this.setState({ openModal: true });
  };

  handleClose = () => {
    this.setState({ openModal: false });
  };

  renderModal(fieldData) {
    return (
      <HyperlinkInterstitialModal
        link={fieldData.url}
        isOpen={this.state.openModal}
        onRequestClose={this.handleClose} />
    );
  }

  render() {
    const { fieldData, height, width, textScale, ...props } = this.props;

    const fontFamily = fieldData.fontFamily || DEFAULT_FONT_FAMILY;
    const fontSize = fieldData.fontSize || DEFAULT_FONT_SIZE;

    const className = classnames(
      textStyles[`font--${fontFamily}`],
      styles.hyperlink,
    );

    const style = {
      height,
      width,
      fontSize: `${fontSize}px`,
    };

    return (
      <React.Fragment>
        <div
          style={style}
          ref={this.self}
          {...props}
          className={className}
          alt={fieldData.url}
          title={fieldData.url}
          onClick={this.handleClick}
          tabIndex="-1"
        >
          {fieldData.value}
        </div>
        {this.renderModal(fieldData)}
      </React.Fragment>
    );
  }
}
